import PropTypes from 'prop-types'

import { TpmsBatteryLevels } from '../../models/tpms/tpms-battery-levels-enum'
import { TpmsReceiverTypes } from '../../models/tpms/tpms-receiver-types-enum'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} TpmsTireLocation
 * @property {string} batteryStatus
 * @property {number} normalizedPressure
 * @property {number} pressure
 * @property {string} receiverType
 * @property {number} temperature
 * @property {ISO8601} time
 */
export const tpmsSensorStatePropType = PropTypes.shape({
    batteryStatus: PropTypes.oneOf(Object.values(TpmsBatteryLevels)),
    normalizedPressure: PropTypes.number,
    pressure: PropTypes.number,
    receiverType: PropTypes.oneOf(Object.values(TpmsReceiverTypes)),
    temperature: PropTypes.number,
    time: iso8601PropType
})
